import { Option } from '@components/Option';
import { Select } from '@components/Select';
import { HomeIcon } from '@src/assets';
import React from 'react';
import * as styled from './styled/HomeTypeGroup.styled';
import { TitleGroup } from './TitleGroup';

const homeTypes = ['apt/loft', 'condo', 'hotel', 'house', 'shared room', 'special', 'townhome'];

export const HomeTypeGroup: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    return (
        <styled.HomeTypeGroup>
            <TitleGroup title="Home type" Icon={HomeIcon} />
            <Select disabled={disabled} name={'propertyType'}>
                {homeTypes.map((homeType) => (
                    <Option key={homeType} value={homeType}>
                        {homeType}
                    </Option>
                ))}
            </Select>
        </styled.HomeTypeGroup>
    );
};
